var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderDetailsContent',{attrs:{"id":_vm.$route.params.id},on:{"editOrder":function($event){return _vm.$router.push({ name: 'edit-order', params: $event })},"goToDefaultOrdersList":function($event){return _vm.goToDefaultOrdersList()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }